<template>
  <responsive-modal v-model="visible" size="lg">
    <div class="recommendation-modal p-3">
      <div class="pb-3 text-secondary d-flex justify-content-between">
        <span>
          Indique e Ganhe Blitzpay
        </span>
        <button class="btn btn-sm" @click="visible = false">
          <i class="icon-x text-secondary" />
        </button>
      </div>
      <div class="card mt-6 p-5 overflow-y-scroll">
        <recommendation-document />
      </div>
      <b-form-checkbox v-model="is_accepted" class="mt-2 pb-6">
        <small>
          Li e aceito os termos e condições.
        </small>
      </b-form-checkbox>
      <div class="d-flex justify-content-end mt-6">
        <button class="btn btn-secondary px-6 mr-3" @click="visible = false">
          Não aceito
        </button>
        <button
          class="btn btn-primary"
          :disabled="!is_accepted"
          @click="accept"
        >
          <div v-if="loading">
            <b-spinner variant="primary" />
          </div>
          <span v-else>
            Aceito
          </span>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import RecommendationDocument from "./RecommendationDocument.vue";
export default {
  components: { RecommendationDocument },
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      is_accepted: false,
      loading: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
    }
  },
  methods: {
    accept() {
      this.loading = true;
      this.$store
        .dispatch("rewards/acceptTerms")
        .then(() => {
          this.visible = false;
          this.$router.push({ name: "recommendation-program" });
        })
        .catch(() => this.$message.error("Erro ao aceitar termos"))
        .finally(() => {
          this.loading = false;
          this.is_accepted = false;
          this.$store.dispatch("postLogin");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.recommendation-modal {
  .card {
    background: #f7f7f9;
    min-height: 300px;
    max-height: 300px;
    font-size: 14px;
  }
  ::v-deep .btn-secondary {
    background: rgba(119, 120, 142, 0.08);
    border-color: transparent;
    color: rgba(87, 88, 107, 0.88);
  }
}
</style>
